var Backbone = require('backbone')
  , _ = require('underscore')
  , handleLinkClicked = require('../mixins/handleLinkClicked')
  , NavManager = require('../NavManager')

var ued = window.ued || {}
  , tmpl = require('./tmpl.handlebars')

module.exports = Backbone.View.extend({
  initialize: function() {
    this.listenTo(this.model, 'changeRoute', this.renderNavs, this)
    this.breadcrumbs = $('.local-bar .breadcrumbs')
  }
, events: {
    // 'click a[href!="#"]': 'handleLinkClicked'
  }
, renderNavs: function() {
    var navConfigs = ued.navConfigs
      , navManager = new NavManager()

    this.$('.list-cate').html(
      tmpl(navConfigs, { helpers: navManager.getRenderNavHelpers() })
    )

    this.renderBreadcrumbs()
  }
, renderBreadcrumbs: function() {
    var label = _.chain(this.$('.pn-bd .current'))
      .map(function(element) {
        element = $(element)
        return $.trim(element.text())
      })
      .filter(function(text) { return text !== '不限' })
      .value().join(' ')

    var labelContainer = this.breadcrumbs.find('span')

    if (!labelContainer.length) {
      this.breadcrumbs.append(' > ')
      labelContainer = $('<span>')
      this.breadcrumbs.append(labelContainer)
    }

    if (!label) {
      var breadcrumbContents = this.breadcrumbs.contents()
      this.breadcrumbs.html(
        breadcrumbContents.splice(0, breadcrumbContents.length - 2)
      )
    } else {
      labelContainer.text(label)
    }
  }
, handleLinkClicked: handleLinkClicked
})
